export const acceptableExtensions = [".pdf", ".jpg", ".jpeg", ".png", ".doc", ".docx", ".msg", ".html", ".htm",
    ".odt", ".xsl", ".xlsx", ".ods", ".ppt",".pptx", ".txt"];
